import React from 'react';
import { useLocation, Navigate } from 'react-router-dom';

import { Context } from '../context/DataContext';

const RequireAuth = ({ children }) => {
  const location = useLocation();
  const {
    state: { loginInfo },
  } = React.useContext(Context);

  if (!loginInfo || !loginInfo.dealerNo) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

export default RequireAuth;
